import Base from "../Base";

export default class Attachment extends Base {
    /**
     * {string}
     */
    fileId;
    /**
     * {string}
     */
    name;
    /**
     * {string}
     */
    type;
    /**
     * {number}
     */
    size;
    /**
     * {string}
     */
    imageRatio;

    integers = ['size'];

    constructor(data) {
        super();
        this.setUp(this, data);
    }
}